import store from '@/store'
import { post, get } from '@/utils/request'

const moduleConfigWizard = 'configWizard'
/**
 *
 * @description 配置向导信息：获取信息
 * @param {Object} data
 */
export function getConfigurationWizardInfo() {
  return get(`${moduleConfigWizard}/get`)
}
/**
 *
 * @description 配置向导信息：设置信息
 * @param {Object} data
 */
export function setConfigurationWizardInfo({ show, index, userIndex, isJoinUserExperiencePlan }) {
  userIndex = userIndex !== undefined ? userIndex : store.state.permission.configurationWizardUserIndex
  isJoinUserExperiencePlan =
    isJoinUserExperiencePlan !== undefined ? isJoinUserExperiencePlan : store.state.permission.isJoinUserExperiencePlan
  const data = { show, index, isJoinUserExperiencePlan, customDataArr: [{ key: 'userIndex', value: userIndex }] }
  return post(`${moduleConfigWizard}/set`, data)
}

/**
 *
 * @description 配置向导信息：设置信息
 * @param {Object} data
 */
export function getBetaVersion() {
  return get('deploy/getBetaVersion')
}

export function viewBetaVersion(
  params = { alreadyViewAdminBetaVersion: false, alreadyViewTerminalBetaVersion: false }
) {
  return post('deploy/viewBetaVersion', params)
}
